// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2209":"d04a9ee238a3b061","3287":"9857d7a6e3f6ab53","8837":"83f3166b071f7e44"}[chunkId] + ".css";
};